







































































import { Component, Mixins } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../../base/components/system/selectors/mixins";
import { FormatStructureEditableMixin } from "../../mixins";

interface IReadingLimit {
  section: string;
  target: string;
  limit: boolean;
}

@Component({
  components: {
    OptionDropDownSelector,
  },
})
export default class FormatPropertyLimitReadingLimitsEditTool extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  // TODO FormatStructureEditableMixin、FormatStructureEditor、IEditableFormatStructureに移動する
  defaultReadingLimit: boolean = true;
  defaultReadingLimitOptions: StandardOption<boolean>[] = [
    new StandardOption<boolean>("閲覧可", true),
    new StandardOption<boolean>("閲覧不可", false),
  ];
  readingLimitsType: string = "0";
  readingLimitsTypeOptions: StandardOption<string>[] = [
    new StandardOption<string>("閲覧を一切許可しない", "0"),
    new StandardOption<string>("閲覧履歴を記録した上での閲覧が可能", "1"),
    new StandardOption<string>("閲覧履歴を記録した上での閲覧が可能(ログイン認証なし)", "2"),
    new StandardOption<string>("閲覧履歴を記録した上での閲覧が可能(メッセージ非表示)", "3"),
  ];
  readingLimits: IReadingLimit[] = [
    { section: "ユーザ", target: "クライオ管理者", limit: true },
    { section: "記載者", target: "記載者ユーザ", limit: true },
    { section: "所属診療科", target: "記載者の所属診療科", limit: true },
  ];
  selectedReadingLimit: IReadingLimit = null;

  get hasSelected(): boolean {
    return !!this.selectedReadingLimit;
  }

  get hasSelectedLimit(): boolean {
    return this.hasSelected && this.selectedReadingLimit.limit;
  }

  get hasSelectedUnLimit(): boolean {
    return this.hasSelected && !this.selectedReadingLimit.limit;
  }

  openDialog(): void {
    this.$notImplemented();
  }

  setSelectedLimit(value: boolean): void {
    this.selectedReadingLimit.limit = value;
  }

  moveSelectedLimit(): void {
    this.$notImplemented();
  }

  removeSelectedLimit(): void {
    this.$notImplemented();
  }

  async handleSelectionChanged(row: IReadingLimit): Promise<void> {
    this.selectedReadingLimit = row;
  }
}
